import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class ReferenceDataService {
  // 获取类别列表
  static async getCategory(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/ReferenceDataCate?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增类别
  static async addCategory(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/ReferenceDataCate', payload))
    return Callback(err, res)
  }
  // 编辑类别
  static async editCategory(payload) {
    const [err, res] = await To(
      wizStandardInstance.put(`/api/std/ReferenceDataCate/${payload.id}`, payload)
    )
    return Callback(err, res)
  }
  // 删除类别-批量
  static async deleteCategory(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/ReferenceDataCate/many', { data: payload })
    )
    return Callback(err, res)
  }
  // 获取字典值
  static async getCategoryItem(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/ReferenceDataItem?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增字典值
  static async addCategoryItem(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/ReferenceDataItem', payload))
    return Callback(err, res)
  }
  // 编辑字典值
  static async editCategoryItem(payload) {
    const [err, res] = await To(
      wizStandardInstance.put(`/api/std/ReferenceDataItem/${payload.id}`, payload)
    )
    return Callback(err, res)
  }
  // 删除字典值-批量
  static async deleteCategoryItem(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/ReferenceDataItem/many', { data: payload })
    )
    return Callback(err, res)
  }
  // 导出
  static async exportReferenceDataCate(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/ReferenceDataCate/export', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 检查名字是否存在
  static async checkNameExisted(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/ReferenceDataCate/check-name-is-existed?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
}
